import { defineMessages } from "react-intl";

const messages = defineMessages({
  columnStatus: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.columnStatus",
    defaultMessage: "Status",
  },
  columnAlert: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.columnAlert",
    defaultMessage: "Flags",
  },
  columnPatient: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.columnPatient",
    defaultMessage: "Patient",
  },
  columnDateTime: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.columnDateTime",
    defaultMessage: "Date",
  },
  columnLocation: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.columnLocation",
    defaultMessage: "Location",
  },
  columnStudies: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.columnStudies",
    defaultMessage: "Studies",
  },

  statusApproved: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.statusApproved",
    defaultMessage: "Approved",
  },
  statusRequiresReview: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.statusRequiresReview",
    defaultMessage: "To review",
  },
  statusInReview: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.statusInReview",
    defaultMessage: "In review",
  },

  tooltipStat: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.tooltipStat",
    defaultMessage: "Appointment has STAT addon",
  },
  tooltipAdditionalViews: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.tooltipAdditionalViews",
    defaultMessage: "Additional views",
  },
  tooltipHasPriority: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.tooltipHasPriority",
    defaultMessage: "Has Priority",
  },
  tooltipContactingPatientRequired: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.tooltipContactingPatientRequired",
    defaultMessage: "Contact Patient",
  },
  tooltipHasPreviousAppointments: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.tooltipHasPreviousAppointments",
    defaultMessage: "Has previous appointments",
  },

  btnView: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.btnView",
    defaultMessage: "View Appointment",
  },
  btnReview: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.btnReview",
    defaultMessage: "Review",
  },
  btnEdit: {
    id: "AppointmentAIReport.AppointmentAIReportsTableGrid.btnEdit",
    defaultMessage: "Edit",
  },
});

export default messages;
